module.exports = __webpack_public_path__ + "static/img/mso高速凹版直印印花机印花机.b14b7c6a.jpg";